<template>
  <Listbox
    v-model="selected"
    as="div"
  >
    <ListboxLabel class="block text-sm font-medium text-gray-700">
      Set language
    </ListboxLabel>
    <div class="mt-1 relative">
      <ListboxButton class="relative w-full bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
        <span class="flex items-center">
          <img
            :src="selected.image"
            alt=""
            class="flex-shrink-0 h-4 w-6 mt-1.5"
          >
          <span class="ml-3 block truncate">{{ selected.name }}</span>
        </span>
        <span class="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
          <ChevronUpDownIcon
            class="h-5 w-5 text-gray-400"
            aria-hidden="true"
          />
        </span>
      </ListboxButton>
      <transition
        leave-active-class="transition ease-in duration-100"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <ListboxOptions class="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
          <ListboxOption disabled>
            <label
              for="search"
              class="sr-only"
            >Search language</label>
            <div class="relative">
              <div
                class="pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center"
              >
                <SearchIcon
                  class="h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
              </div>
              <input
                id="search"
                ref="search"
                v-model="searchQuery"
                name="search"
                class="block w-full bg-white border border-gray-300 rounded-md py-2 pl-10 pr-3 text-sm placeholder-gray-500 focus:outline-none focus:text-gray-900 focus:placeholder-gray-400 focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                placeholder="Search for languages"
                type="search"
                list="language"
                v-text="Search"
              >
            </div>
          </ListboxOption>
          <ListboxOption
            v-for="lang in resultQuery"
            :key="lang.id"
            v-slot="{ active, selected }"
            as="template"
            :value="lang"
          >
            <li :class="[active ? 'text-white bg-indigo-600' : 'text-gray-900', 'cursor-default select-none relative py-2 pl-3 pr-9']">
              <div class="flex justify-between">
                <div class="flex flex-row">
                  <img
                    :src="lang.image"
                    alt=""
                    class="flex-shrink-0 h-4 w-6 mt-1.5"
                  >
                  <span :class="[selected ? 'font-semibold' : 'font-normal', 'ml-3 block truncate']">
                    {{ lang.name }}
                  </span>
                </div>
                <span
                  class="text-gray-400"
                  :class="[selected ? 'font-semibold' : 'font-normal', 'ml-3 block truncate']"
                >
                  {{ lang.native }}
                </span>
              </div>

              <span
                v-if="selected"
                :class="[active ? 'text-white' : 'text-indigo-600', 'absolute inset-y-0 right-0 flex items-center pr-4']"
              >
                <CheckIcon
                  class="h-5 w-5"
                  aria-hidden="true"
                />
              </span>
            </li>
          </ListboxOption>
        </ListboxOptions>
      </transition>
    </div>
  </Listbox>
</template>

<script>
import {
  Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions,
} from '@headlessui/vue';
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/vue/24/solid';

export default {
  components: {
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    CheckIcon,
    ChevronUpDownIcon,
  },
  props: {
    modelValue: {
      required: false,
      default: null,
    },
  },
  emits: ['update:modelValue'],

  data() {
    return {
      searchQuery: '',
      results: [],
      languages: [],
      selected: {
        id: null,
        name: 'Search for languages',
        image: '/img/flags/placeholder.png',
      },
    };
  },
  computed: {
    resultQuery() {
      if (this.searchQuery) {
        return this.languages.filter((item) => this.searchQuery
          .toLowerCase()
          .split(' ')
          .every((v) => item.name.toLowerCase().includes(v)));
      }

      return this.languages;
    },
  },
  watch: {
    selected() {
      if (this.selected.id !== null) {
        this.$emit('update:modelValue', this.selected.id);
      }
    },
  },
  created() {
    axios
      .get('/api/languages')
      .then((response) => {
        this.languages = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>
